export default __webpack_public_path__ + "static/media/1L_Sprayer_MainNew_new.3f1b96c7.png";